import { Link, LinkProps } from 'react-router-dom'
import { useLocale } from 'src/hooks/use-locale'

type LocalizedLinkProps = LinkProps & {
  to: string
}

/**
 * Link component that automatically adds the current locale to the URL
 * Similar to next-intl's Link component
 */
export const LocalizedLink = ({ to, ...props }: LocalizedLinkProps) => {
  const { locale } = useLocale()

  // If path already starts with a locale, return as is
  const localizedPath = to.match(/^\/(fr|en)\//)
    ? to
    : `/${locale}${to.startsWith('/') ? to : `/${to}`}`

  return <Link to={localizedPath} {...props} />
}
